require('parsleyjs');

import ContactForm from './contact-form';
import FormValidation from './form-validation';

let ContactPopup = function (RecaptchaForm) {

    this.initialised = false;

    if (this.initialised) {
        return;
    }

    this.init(RecaptchaForm);
};

ContactPopup.prototype.init = function (RecaptchaForm) {

    $(document).on('click', '[data-popup]', (e) => {
        this.popup({
            src: $(e.currentTarget).data('popup'),
            callbacks: {
                ajaxContentAdded: function () {
                    FormValidation.init('#contactPopup');
                    ContactForm.init($('[data-type="contact-form"]'));
                    new RecaptchaForm(document.getElementById('contactPopup'));
                }
            }
        })
    });

    this.initialised = true;
};

ContactPopup.prototype.popup = function (data) {
    $.magnificPopup.open({
        fixedContentPos: true,
        autoFocusLast: false,
        closeOnBgClick: true,
        items: {
            src: data.src,
            type: 'ajax'
        },
        callbacks: data.callbacks
    });
};

/**
 * Static initialiser
 */
ContactPopup.init = function (RecaptchaForm) {
    return new ContactPopup(RecaptchaForm);
};

export default ContactPopup;
